<template>
  <div>
    <div class="anchor">
      <!-- <div class="anchor__service anchor__icon">
      <i
        class="iconfont pdp_rightsuspension_shoppingcart cart"
        @click="gotoCart"
      ></i>
      <span v-if="count" class="count">{{ count }}</span>
    </div> -->
      <div class="anchor__service anchor__icon">
        <i
          class="iconfont health__customer"
          @mousemove="showService"
          @mouseout="serviceHide"
          @click="service"
        ></i>
      </div>
      <div class="anchor__phone anchor__icon">
        <i
          class="iconfont health__tel"
          @mouseover="phoneShow"
          @mouseout="phoneHide"
        ></i>
      </div>
      <div class="anchor__code anchor__icon">
        <i
          class="iconfont health__qrcode"
          @mouseover="qrcodeShow"
          @mouseout="qrcodeHide"
        ></i>
      </div>
      <div
        class="anchor__compare anchor__icon"
        v-if="
          flag_hidden != 1 &&
          hasPK &&
          isShowCompareBtn &&
          !unionBS.includes(publicMethod.unionFlag())
        "
      >
        <i
          class="iconfont health__contrast"
          @mousemove="buttonShow"
          @mouseout="buttonHide"
          @click="showCompareList"
        ></i>
      </div>
      <div class="anchor__totop anchor__icon" v-if="anchor_flag" id="top">
        <i
          class="iconfont health__back_top"
          v-if="!totophover"
          @mouseenter="bottomhover"
        ></i>
        <div
          v-else
          @mouseleave="bottomout"
          @click="totop"
          class="anchor__totopfont"
          :style="`line-height:${$t('backtoTop') === 'Top' ? 40 : 20}px`"
        >
          {{ $t("backtoTop") }}
        </div>
      </div>

      <div
        class="anchor__phone_hover"
        v-show="showPhone"
        @mouseover="phoneShow"
        @mouseout="phoneHide"
      >
        <div class="anchor__tiptitle">{{ $t("customerServiceHotline") }}</div>
        <div class="anchor__actphone">{{ tel }}</div>
        <div class="anchor__sevicetime">{{ $t("openTime") }}</div>
        <div class="anchor__sevicetime">{{ $t("PACKAGE_SERVICE_TIME") }}</div>
      </div>

      <div
        class="anchor__qrcode_hover"
        v-show="showqrcode"
        @mouseover="qrcodeShow"
        @mouseout="qrcodeHide"
      >
        <img src="@/assets/images/qrcode.jpg" alt />
        <div class="anchor__sao">{{ $t("code") }}</div>
      </div>
      <div
        class="anchor__package_hover"
        v-show="showbutton"
        @mousemove="buttonShow"
        @mouseout="buttonHide"
        @click="showCompareList"
        v-if="
          flag_hidden != 1 &&
          hasPK &&
          isShowCompareBtn &&
          !unionBS.includes(publicMethod.unionFlag())
        "
      >
        <div class="anchor__compare">{{ $t("plansComparison") }}</div>
      </div>

      <div
        class="anchor__service_hover"
        v-show="serviceShow"
        @mousemove="showService"
        @mouseout="serviceHide"
        @click="service"
      >
        <div class="anchor__compareService">{{ $t("onlineService") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryString, unionFlag } from "../../utils";
import { mapState } from "vuex";
import { UNION_BS } from "@/utils/constant";
export default {
  name: "anchor",
  components: {},
  data() {
    return {
      tel: unionFlag() ? "400-618-2999" : "400-003-1010",
      hasPK: false,
      anchor_flag: false,
      showPhone: false,
      showqrcode: false,
      showbutton: true,
      totophover: false,
      serviceShow: false,
      path: location.pathname,
      isShowCompareBtn: false,
      chatShow: false,
      unionBS: UNION_BS,
    };
  },
  watch: {
    $route: function () {
      this.isShowCompareBtn =
        this.$route.path.includes("/package/list") ||
        this.$route.path.includes("/organ/details") ||
        this.$route.path.includes("/package/details");
    },
  },
  props: ["flag_hidden"],
  methods: {
    service() {
      try {
        window.qimoChatClick();
      } catch (error) {
        console.log(error);
      }
    },
    showService() {
      this.serviceShow = true;
    },
    serviceHide() {
      this.serviceShow = false;
    },
    phoneShow() {
      this.showPhone = true;
    },
    phoneHide() {
      this.showPhone = false;
    },
    qrcodeShow() {
      this.showqrcode = true;
    },
    qrcodeHide() {
      this.showqrcode = false;
    },
    buttonShow() {
      this.showbutton = true;
    },
    buttonHide() {
      this.showbutton = false;
    },
    showCompareList() {
      if (this.compareShow) {
        this.$store.commit("compareListControl", false);
      } else {
        this.$store.commit("compareListControl", true);
      }
    },
    bottomhover() {
      this.totophover = true;
    },
    bottomout() {
      this.totophover = false;
    },
    totop() {
      let scrollToptimer = setInterval(function () {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var speed = top / 3;
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top == 0) {
          clearInterval(scrollToptimer);
          this.totophover = false;
        }
      }, 30);
    },
    //监听是否滑动显示回到顶部
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop != 0) {
        this.anchor_flag = true;
      } else {
        this.anchor_flag = false;
        this.totophover = false;
      }
    },
    showChat() {
      // 跳转到我的咨询单列表
      this.$router.push({
        path: "/OnlineOrderList",
      });
      this.$store.commit("changeNewMsg", false);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.isShowCompareBtn =
      this.path.includes("/package/list") ||
      this.path.includes("/organ/details") ||
      this.path.includes("/package/details");
  },
};
</script>

<style lang="less" scoped>
@color-main: #3d96e2;
.anchor {
  z-index: 2000;
  position: fixed;
  right: 0;
  bottom: 200px;
  width: 60px;
  box-sizing: border-box;
  &__icon {
    margin-bottom: 2px;
    background-color: #f7f7f7;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    position: relative;
    .iconfont {
      font-size: 60px;
    }
    .cart {
      font-size: 20px;
    }
    &:hover {
      background-color: @color-main;
      color: white;
    }
    .count {
      position: absolute;
      color: #f44545;
      right: 12px;
      top: -10px;
      font-size: 10px;
      padding: 0 2px;
    }
  }
  &__phone_hover {
    cursor: default;
    position: absolute;
    right: 60px;
    top: 15px;
    width: 187px;
    height: 142px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    padding: 20px;
  }
  &__phone_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 25px;
    line-height: 20px;
  }
  &__tiptitle {
    color: #999;
    font-size: 12px;
  }
  &__actphone {
    color: #333;
    font-weight: 600;
  }
  &__sevicetime {
    color: #999;
    margin-top: 10px;
  }
  &__qrcode_hover {
    cursor: default;
    position: absolute;
    right: 60px;
    top: 45px;
    font-size: 14px;
    color: #333333;
    width: 190px;
    height: 215px;
    padding: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    img {
      width: 170px;
      height: 170px;
    }
  }
  &__qrcode_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 100px;
    line-height: 20px;
  }
  &__package_hover {
    position: absolute;
    right: 60px;
    top: 186px;
    width: 172px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    line-height: 58px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }
  &__service_hover {
    position: absolute;
    right: 60px;
    top: 0px;
    width: 172px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    line-height: 58px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }
  &__service_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 25px;
    line-height: 20px;
  }
  &__package_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 25px;
    line-height: 20px;
  }
  &__totopfont {
    width: 100%;
    height: 100%;
    padding: 10px 10px 10px 13px;
    line-height: 20px;
    letter-spacing: 2px;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
  }
  &__totopfont:hover {
    background-color: @color-main;
    color: white;
  }
  .health__back_top {
    display: block;
  }
  // &__totopfont:hover {
  //   background-color: #08d0c2;
  //   color: white;
  // }
  &__chat_hover {
    position: absolute;
    right: 60px;
    top: 116px;
    width: 195px;
    height: 215px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    font-weight: 400;
    line-height: 20px;
    padding-top: 10px;
    p {
      margin-top: 5px;
    }
  }
  &__chat_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 108px;
    line-height: 20px;
  }
}
.df_en {
  .anchor__phone_hover {
    width: 212px;
    height: 144px;
  }
}
.newMessage {
  position: absolute;
  display: inline-block;
  width: 6px;
  height: 6px;
  background: rgba(244, 69, 69, 1);
  border-radius: 50%;
  top: 15px;
  right: 22px;
}
.df_en {
  .anchor__chat_hover {
    height: 228px;
    p {
      text-align: left;
      padding-left: 12px;
    }
  }
}
</style>
